import Vue from 'vue'
import Router from 'vue-router'
import VueClipboard from 'vue-clipboard2';

Vue.use(Router);
Vue.use(VueClipboard)

export default new Router({
    mode: 'history',
    routes: [
        {path: '/', component: () => import('./views/Dashboard')},
        {path: '/top-sales/:id', props: true, component: () => import('./views/TopSales')},
        {path: '/login', component: () => import('./views/Login')},
        {path: '/forgot', component: () => import('./views/Forgot')},
        {path: '/change', component: () => import('./views/Profile')},
        {path: '/reset/:token', component: () => import('./views/Reset'), props: true},
        {path: '/department', component: () => import('./views/account/Department')},
        {path: '/admin-user', component: () => import('./views/account/AdminUser')},
        {path: '/admin-user-kpi', component: () => import('./views/account/KPI')},
        {path: '/category', component: () => import('./views/account/Category')},
        {path: '/release-note', component: () => import('./views/ReleaseNote')},
        {path: '/host', component: () => import('./views/phone/Host')},
        {path: '/gateway', component: () => import('./views/phone/Gateway')},
        {path: '/country', component: () => import('./views/Country')},
        {path: '/phone-network', component: () => import('./views/phone/PhoneNetwork')},
        {path: '/client', component: () => import('./views/client/Client')},
        {path: '/client-lead', component: () => import('./views/client/Lead.vue')},
        {path: '/client-register', component: () => import('./views/client/ClientRegister')},
        {path: '/client-kyc', component: () => import('./views/client/client-kyc/List.vue')},
        {path: '/client-trial-extend-request', component: () => import('./views/client/ClientTrialExtendRequest')},
        {path: '/plan', component: () => import('./views/client/Plan')},
        {path: '/promotion', component: () => import('./views/client/Promotion')},
        {path: '/credit-deposit', component: () => import('./views/finance/credit-deposit/CreditDeposit')},
        {path: '/credit-transaction', component: () => import('./views/finance/CreditTransaction')},
        {path: '/number', component: () => import('./views/phone/Number')},
        {path: '/system-recording', component: () => import('./views/phone/SystemRecording')},
        {path: '/report/call', component: () => import('./views/report/Call')},
        {path: '/report/client', component: () => import('./views/report/ClientOverview.vue')},
        {path: '/report/referral', component: () => import('./views/report/Referral')},
        {path: '/report/contract', component: () => import('./views/report/Contract')},
        {path: '/report/system', component: () => import('./views/report/System')},
        {path: '/report/call-fee-overview', component: () => import('./views/report/CallFeeOverview')},
        {path: '/report/call-fee-detail', component: () => import('./views/report/CallFeeDetail')},
        {path: '/report/call-package', component: () => import('./views/report/CallPackage.vue')},
        {path: '/report/plan-order', component: () => import('./views/report/PlanOrder')},
        {path: '/report/promotion', component: () => import('./views/report/Promotion')},
        {path: '/report/finance', component: () => import('./views/report/Finance')},
        {path: '/report/credit-balance', component: () => import('./views/report/CreditBalance')},
        {path: '/report/usage', component: () => import('./views/report/usage/Usage.vue')},
        {path: '/report/quantity', component: () => import('./views/report/Quantity.vue')},
        {path: '/sms', component: () => import('./views/sms/SMS')},
        {path: '/email-sender', component: () => import('./views/email/EmailSender')},
        {path: '/email-gateway', component: () => import('./views/email/EmailGateway')},
        {path: '/email-template-callio', component: () => import('./views/email/EmailTemplateCallio')},
        {path: '/email-history', component: () => import('./views/email/History')},
        {path: '/plan-order', component: () => import('./views/finance/plan-order/PlanOrder')},
        {path: '/client-package', component: () => import('./views/finance/client-package/ClientPackage')},
        {path: '/ai-gateway', component: () => import('./views/ai/Gateway')},
        {path: '/ai-campaign', component: () => import('./views/ai/Campaign')},
        {path: '/ai', component: () => import('./views/ai/AI')},
        {path: '/call-campaign', component: () => import('./views/call/Campaign')},
        {
            path: '/phone-number-subscription-transaction',
            component: () => import('./views/finance/PhoneNumberSubscriptionTransaction')
        },
        {
            path: '/phone-number-setup-transaction',
            component: () => import('./views/finance/PhoneNumberSetupTransaction')
        },
        {
            path: '/sms-brand-name-register-transaction',
            component: () => import('./views/finance/SMSBrandNameRegisterTransaction')
        },
        {
            path: '/sms-brand-name-subscription-transaction',
            component: () => import('./views/finance/SMSBrandNameSubscriptionTransaction')
        },
        {
            path: '/number-brand-name-setup-transaction',
            component: () => import('./views/finance/NumberBrandNameSetupTransaction')
        },
        {
            path: '/call-refund-subscription-transaction',
            component: () => import('./views/finance/CallRefundSubscriptionTransaction')
        },
        {
            path: '/number-brand-name-subscription-transaction',
            component: () => import('./views/finance/NumberBrandNameSubscriptionTransaction')
        },
        {
            path: '/phone-number-commit-transaction',
            component: () => import('./views/finance/PhoneNumberCommitTransaction.vue')
        },
        {
            path: '/viber-brandname-commit-transaction',
            component: () => import('./views/finance/ViberBrandNameCommitTransaction.vue')
        },
        {path: '/commission-config', component: () => import('./views/finance/CommisionConfig')},
        {path: '/dnc', component: () => import('./views/phone/DNC')},
        {path: '/call', component: () => import('./views/client/Call')},
        {path: '/commission', component: () => import('./views/commission/Commission')},
        {path: '/admin-user-commission', component: () => import('./views/commission/AdminUserCommission')},
        {path: '/fault-detection-keyword', component: () => import('./views/fault-detection/Keyword')},
        {path: '/fault-detection-call', component: () => import('./views/fault-detection/Call')},
        {path: '/fault-detection-chat', component: () => import('./views/fault-detection/Chat.vue')},
        {path: '/kpi-setup', component: () => import('./views/commission/KPISetupList')},
        {path: '/token', component: () => import('./views/Token')},
        {path: '/etc', component: () => import('./views/Etc')},
        {path: '/tool', component: () => import('./views/tool/Tool')},
        {path: '/carrier-gateway', component: () => import('./views/order/CarrierGateway.vue')},
        {path: '/print-template', component: () => import('./views/order/PrintTemplate.vue')},
        {path: '/admin-product', component: () => import('./views/ecommerce/Product')},
        {path: '/admin-order', component: () => import('./views/ecommerce/Order')},
        {path: '/viber', component: () => import('./views/viber/Viber')},
        {path: '/zns', component: () => import('./views/zns/ZNS')},
        {path: '/webhook-vietguys', component: () => import('./views/webhook-vietguys/WebhookVietguys.vue')},
        {path: '/message-campaign', component: () => import('./views/message/Campaign')},
        {path: '/email-campaign', component: () => import('./views/email/EmailCampaign')},
        {path: '/client-cdp', component: () => import('./views/finance/ClientCDP')},
        {path: '/client-chatbot', component: () => import('./views/finance/client-chatbot/ClientChatbot')},
        {path: '/error', component: () => import('./views/Error')},
        {path: '/error-notification', component: () => import('./views/ErrorNotification')},
        {path: '/admin-popup', component: () => import('./views/Popup')},
        {path: '/social-network-account', component: () => import('./views/message/SocialNetworkAccounts.vue')},
        {path: '/mapping-zalo-user', component: () => import('./views/zalo-user/MappingZaloUser.vue')},
        {path: '/activity-history', component: () => import('./views/ActivityHistory.vue')},
        {path: '/admin-call', component: () => import('./views/admin-call/List.vue')},
        {path: '/admin-call-translate', component: () => import('./views/admin-call/Translate.vue')},
        {path: '/admin-call-report', component: () => import('./views/admin-call/Report.vue')},
        {path: '/lookup-call', component: () => import('./views/lookup/Call.vue')},
        {path: '/lookup-customer', component: () => import('./views/lookup/Customer.vue')},
        {path: '/client-bot', component: () => import('./views/message/ClientBot.vue')},
        {
            path: '/social-network-account-history',
            component: () => import('./views/message/SocialNetworkAccountsHistory.vue')
        },
        {path: '/bot-detect-history', component: () => import('./views/message/BotDetectHistory.vue')},
        {path: '/point-transaction-history', component: () => import('./views/message/PointTransactionHistory.vue')},
        {path: '/chat-history', component: () => import('./views/message/ChatHistory.vue')},
        {path: '/invoice-info', component: () => import('./views/client/invoice-info/InvoiceInfo.vue')},
        {path: '/sitemap', component: () => import('./views/sitemap/Sitemap.vue')},
        {path: '/invoice-gateway', component: () => import('./views/vat-invoice/InvoiceGateway.vue')},
        {path: '/invoice-plan', component: () => import('./views/vat-invoice/InvoicePlan.vue')},
        {path: '/invoice-plan-order', component: () => import('./views/finance/InvoicePlanOrder.vue')},
        {path: '/invoice-setup', component: () => import('./views/vat-invoice/InvoiceSetup.vue')},
        {path: '/hilo-invoice-log', component: () => import('./views/vat-invoice/HiloInvoiceLog.vue')},
        {path: '/fault-detection-ip', component: () => import('./views/fault-detection/IP.vue')},
        {path: '/ai-assistant', component: () => import('./views/ai-assistant/Dashboard.vue')},
        {path: '/ai-assistant-logs', component: () => import('./views/ai-assistant/Logs.vue')},
        {path: '*', redirect: '/'}
    ],
})
